import { Registry } from '@react-registry'

export const paragraph = () => {
    return {
        type: 'p'
    }
}

Registry.register(paragraph, { id: 'P', registry: 'deserializer' })